import React from "react";
import { ComponentTitle, PageTitleLastCol } from "../custom-components";
import { BatchJobsTable } from "./BatchJobsStyledComponents";
import useScreenSizeHook from "../utils/useScreenSizeHook";
import { Col, Row } from "antd";
import { useBatchJobsHook } from "./hooks/useBatchJobsHook";

const BatchJobsComponent = () => {
	const { height } = useScreenSizeHook();
	const {  getColumnsBatchJobs, batchJobsData, isLoading, pagination, handleTableChange } = useBatchJobsHook();
	
	return (
		<>
			<Row justify="space-between" align="middle">
				<Col>
					<ComponentTitle>Batch Jobs</ComponentTitle>
				</Col>
				<PageTitleLastCol>
				</PageTitleLastCol>
			</Row>
			<BatchJobsTable
				columns={getColumnsBatchJobs()}
				dataSource={batchJobsData}
				loading={isLoading}
				onChange={handleTableChange}
				pagination={pagination}
				bordered={true}
			/>
		</>
	);
};

export default BatchJobsComponent;
